import { MicroAgentInstance } from '@vp/newrelic-browser-micro-agent'
import { FragmentLogger, LogLevel, convertLogLevel, Logger } from '../fragment-logger.js'

export class MicroAgentLogger extends FragmentLogger {
  protected agent?: MicroAgentInstance
  private readonly microAgentLogLevel: LogLevel

  constructor(logger: Logger, agent: MicroAgentInstance, microAgentLogLevel?: string | number) {
    super(logger)
    this.agent = agent
    this.microAgentLogLevel = convertLogLevel(microAgentLogLevel ?? 'error')
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override postLog(level: LogLevel, message: any, params: Record<string, any> | any[]): void {
    if (level === LogLevel.ERROR) {
      this.agent?.noticeError(message, params)
    }
    if (level < this.microAgentLogLevel) return

    this.agent?.log(message, {
      customAttributes: params,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      level: LogLevel[level] as any,
    })
  }
}
